module.exports = __webpack_public_path__ + "assets/icon_play--dark.ee29b36d.svg";